import { render, staticRenderFns } from "./FormForm.vue?vue&type=template&id=163b60dd&scoped=true"
import script from "./FormForm.vue?vue&type=script&lang=js"
export * from "./FormForm.vue?vue&type=script&lang=js"
import style0 from "./FormForm.vue?vue&type=style&index=0&id=163b60dd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163b60dd",
  null
  
)

export default component.exports